<template>
    <div>
        <div v-show='show' class='layer-pop square'>
            <div class='view-content small-padding' style='width: auto; max-width: 90vw'>
                <button class='close' @click='onClosePop'>
                    <span class='blind'>팝업 닫기</span>
                </button>
                <div class='com-scroll-y'>
                    <p class='pop-tit'>외부문서 미리보기</p>
                    <div style='margin-top: 10px' v-show='fileUrl != ""'>
                        <iframe v-show='checkPDFFile()' :src='fileUrl' width='800' height='640'></iframe>
                        <img v-show='!checkPDFFile()' :src='fileUrl' style='object-fit: contain; width: 800px'>
                    </div>
                    <div class='bottom-btn' style='margin-top: 30px; padding-bottom: 0'>
                        <button class='com-btn' @click='onClosePop'>닫기</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DocumentPreviewDlg',
    props: {
        fileUrl: String,
        show: Boolean,
        close: Function,
    },
    data() {
        return {
            centerId: 0,
        };

    },
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const {getters} = this.$store;
            return getters['auth/staffId'];
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
        },

        onClosePop() {
            this.close();
        },

        checkPDFFile() {
            const nameArr = this.fileUrl.split(".");
            if (nameArr && nameArr.length > 0) {
                if (nameArr[nameArr.length - 1] == "pdf")
                    return true;
            }

            return false;
        }
    },
};
</script>
